import React, { useState } from "react";
import Search from "../include/Search";
import News from "./partials/News";
import "./NewsList.css";

const NewsList = () => {
  const [search, setSearch] = useState("");

  return (
    <div className="news-list-section">
        <Search onSearch={(value) => setSearch(value)} />
        <News search={search} />
    </div>
  );
};

export default NewsList;
